import { render, staticRenderFns } from "./notificationTab.vue?vue&type=template&id=5997fd2e&scoped=true&"
import script from "./notificationTab.vue?vue&type=script&lang=ts&"
export * from "./notificationTab.vue?vue&type=script&lang=ts&"
import style0 from "./notificationTab.vue?vue&type=style&index=0&id=5997fd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997fd2e",
  null
  
)

export default component.exports